export const viewports = ["mobile", "tablet", "desktop"] as const;
type Viewport = (typeof viewports)[number];

export interface ResponsiveRangeProps {
  above?: Exclude<Viewport, "desktop">;
  below?: Exclude<Viewport, "mobile">;
}

export const resolveResponsiveRangeProps = (
  props: ResponsiveRangeProps,
): [boolean, boolean, boolean] => {
  const { above, below } = props;

  if (!above && !below) {
    return [false, false, false];
  }

  const startIndex = above ? viewports.indexOf(above) + 1 : 0;
  const endIndex = below ? viewports.indexOf(below) - 1 : viewports.length - 1;
  const range = viewports.slice(startIndex, endIndex + 1);

  const includeMobile = range.indexOf("mobile") >= 0;
  const includeTablet = range.indexOf("tablet") >= 0;
  const includeDesktop = range.indexOf("desktop") >= 0;

  return [includeMobile, includeTablet, includeDesktop];
};
